module.exports = __webpack_public_path__ + "img/why-deco.0f4e7324.png";